const COUNTRY_FLAG_CODES = {
  Argentina: 'ar',
  Bahamas: 'bs',
  Barbados: 'bb',
  'The Bahamas': 'bs',
  Belize: 'bz',
  Bolivia: 'bo',
  Brazil: 'br',
  Chile: 'cl',
  Colombia: 'co',
  'Costa Rica': 'cr',
  'Dominican Republic': 'do',
  Ecuador: 'ec',
  'El Salvador': 'sv',
  Guatemala: 'gt',
  Guyana: 'gy',
  Haiti: 'ht',
  Honduras: 'hn',
  Jamaica: 'jm',
  Mexico: 'mx',
  Nicaragua: 'ni',
  Panama: 'pa',
  Paraguay: 'py',
  Peru: 'pe',
  Suriname: 'sr',
  'Trinidad & Tobago': 'tt',
  'Trinidad and Tobago': 'tt',
  Uruguay: 'uy',
  Venezuela: 've',
}

export const getFlagCode = (country) => COUNTRY_FLAG_CODES[country] || null

export const getFlagUrl = (country, size = 20) => {
  const code = getFlagCode(country)
  return code ? `https://flagcdn.com/w${size}/${code}.png` : null
}

export const getFlagFallback = (country) => {
  const code = getFlagCode(country)
  return code ? code.toUpperCase() : 'GL'
}
